
const newModel = () => {
    return {
        hocSinhGioiId: null,
        maDinhDanh: null,
        hoten: null,
        ngaySinh: null,
        noiSinh: null,
        danTocId: null,
        tenDanToc: null,
        gioiTinh: null,
        truongchuanQuocgiaId: null,
        tenTruong: null,
        lop: null,
        monHocId: null,
        tenMonHoc: null,
        tenKyThiHsg: null,
        kyThiHsgId: null,
        diem: null,
        thanhTichHsgId: null,
        tenThanhTichHsg: null,
        idKy: null,
        ghiChu: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null
    }
}

const newFEModel = () => {
    return {
        hocSinhGioiId: null,
        maDinhDanh: null,
        hoten: null,
        ngaySinh: null,
        noiSinh: null,
        danTocId: null,
        gioiTinh: null,
        truongchuanQuocgiaId: null,
        lop: null,
        monHocId: null,
        kyThiHsgId: null,
        diem: null,
        thanhTichHsgId: null,
        idKy: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null
    }
}

const fromJson = (item) => {
    return {
        hocSinhGioiId: item.hocSinhGioiId,
        maDinhDanh: item.maDinhDanh,
        hoten: item.hoten,
        ngaySinh: item.ngaySinh,
        noiSinh: item.noiSinh,
        danTocId: item.danTocId,
        tenDanToc: item.tenDanToc,
        gioiTinh: item.gioiTinh,
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        tenTruong: item.tenTruong,
        lop: item.lop,
        monHocId: item.monHocId,
        tenMonHoc: item.tenMonHoc,
        tenKyThiHsg: item.tenKyThiHsg,
        kyThiHsgId: item.kyThiHsgId,
        diem: item.diem,
        thanhTichHsgId: item.thanhTichHsgId,
        tenThanhTichHsg: item.tenThanhTichHsg,
        idKy: item.idKy,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocEnabledDisplay: item.iocEnabled == 1 ? true : false,
        iocDateUpdated: item.iocDateUpdated,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        hocSinhGioiId: item.hocSinhGioiId,
        maDinhDanh: item.maDinhDanh,
        hoten: item.hoten,
        ngaySinh: item.ngaySinh,
        noiSinh: item.noiSinh,
        danTocId: item.danTocId,
        gioiTinh: item.gioiTinh,
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        lop: item.lop,
        monHocId: item.monHocId,
        kyThiHsgId: item.kyThiHsgId,
        diem: item.diem,
        thanhTichHsgId: item.thanhTichHsgId,
        idKy: item.idKy,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocEnabledDisplay: item.iocEnabled == 1 ? true : false,
        iocDateUpdated: item.iocDateUpdated,
    }
}

const errors = () => {
    return {
        hocSinhGioiId: null,
        maDinhDanh: null,
        hoten: null,
        ngaySinh: null,
        noiSinh: null,
        danTocId: null,
        gioiTinh: null,
        truongchuanQuocgiaId: null,
        lop: null,
        monHocId: null,
        kyThiHsgId: null,
        diem: null,
        thanhTichHsgId: null,
        idKy: null,
        ghiChu: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

export const hocSinhGioiGDModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


